// Privātie sludinājumi (C2C) — NESTED category taxonomy (multi-level, like ss.lv).
// Mirrors backend/routes/classifieds.py CLASSIFIED_TAXONOMY (ids MUST match).
// Top-level `emoji` drives the map pin. A listing stores `category` = TOP id,
// `subcategory` = the most specific (leaf) id, `category_path` = full id path.
export const CLASSIFIED_TAXONOMY = [
  { id: 'apgerbi', lv: 'Apģērbi un apavi', en: 'Clothing & shoes', ru: 'Одежда и обувь', emoji: '👕', children: [
    { id: 'apg_sievietem', lv: 'Sieviešu apģērbi', en: "Women's clothing", ru: 'Женская одежда', children: [
      { id: 'apg_siev_virsdrebes', lv: 'Virsdrēbes', en: 'Outerwear', ru: 'Верхняя одежда' },
      { id: 'apg_siev_kleitas', lv: 'Kleitas un svārki', en: 'Dresses & skirts', ru: 'Платья и юбки' },
      { id: 'apg_siev_topi', lv: 'Blūzes un topi', en: 'Tops', ru: 'Топы и блузки' },
      { id: 'apg_siev_apaksvela', lv: 'Apakšveļa un peldkostīmi', en: 'Underwear & swimwear', ru: 'Бельё и купальники' },
    ] },
    { id: 'apg_viriesiem', lv: 'Vīriešu apģērbi', en: "Men's clothing", ru: 'Мужская одежда', children: [
      { id: 'apg_vir_virsdrebes', lv: 'Virsdrēbes', en: 'Outerwear', ru: 'Верхняя одежда' },
      { id: 'apg_vir_krekli', lv: 'Krekli un T-krekli', en: 'Shirts & tees', ru: 'Рубашки и футболки' },
      { id: 'apg_vir_bikses', lv: 'Bikses un džinsi', en: 'Trousers & jeans', ru: 'Брюки и джинсы' },
    ] },
    { id: 'apg_berniem', lv: 'Bērnu apģērbi', en: "Kids' clothing", ru: 'Детская одежда' },
    { id: 'apg_apavi', lv: 'Apavi', en: 'Shoes', ru: 'Обувь', children: [
      { id: 'apg_apavi_siev', lv: 'Sieviešu apavi', en: "Women's shoes", ru: 'Женская обувь' },
      { id: 'apg_apavi_vir', lv: 'Vīriešu apavi', en: "Men's shoes", ru: 'Мужская обувь' },
      { id: 'apg_apavi_bernu', lv: 'Bērnu apavi', en: "Kids' shoes", ru: 'Детская обувь' },
    ] },
    { id: 'apg_aksesuari', lv: 'Aksesuāri', en: 'Accessories', ru: 'Аксессуары', children: [
      { id: 'apg_aks_somas', lv: 'Somas', en: 'Bags', ru: 'Сумки' },
      { id: 'apg_aks_pulksteni', lv: 'Pulksteņi un rotaslietas', en: 'Watches & jewellery', ru: 'Часы и украшения' },
    ] },
  ] },
  { id: 'elektronika', lv: 'Elektronika', en: 'Electronics', ru: 'Электроника', emoji: '📱', children: [
    { id: 'el_telefoni', lv: 'Telefoni', en: 'Phones', ru: 'Телефоны', children: [
      { id: 'el_tel_viedtalruni', lv: 'Viedtālruņi', en: 'Smartphones', ru: 'Смартфоны' },
      { id: 'el_tel_aksesuari', lv: 'Aksesuāri', en: 'Accessories', ru: 'Аксессуары' },
      { id: 'el_tel_viedpulksteni', lv: 'Viedpulksteņi', en: 'Smartwatches', ru: 'Умные часы' },
    ] },
    { id: 'el_datori', lv: 'Datori un planšetes', en: 'Computers & tablets', ru: 'Компьютеры и планшеты', children: [
      { id: 'el_dat_portativie', lv: 'Portatīvie datori', en: 'Laptops', ru: 'Ноутбуки' },
      { id: 'el_dat_stacionarie', lv: 'Stacionārie datori', en: 'Desktops', ru: 'ПК' },
      { id: 'el_dat_komponentes', lv: 'Komponentes', en: 'Components', ru: 'Комплектующие' },
      { id: 'el_dat_plansetes', lv: 'Planšetes', en: 'Tablets', ru: 'Планшеты' },
    ] },
    { id: 'el_tv_audio', lv: 'TV un audio', en: 'TV & audio', ru: 'ТВ и аудио', children: [
      { id: 'el_tv_televizori', lv: 'Televizori', en: 'TVs', ru: 'Телевизоры' },
      { id: 'el_tv_audiosk', lv: 'Audio un skaļruņi', en: 'Audio & speakers', ru: 'Аудио и колонки' },
    ] },
    { id: 'el_foto', lv: 'Foto un video', en: 'Photo & video', ru: 'Фото и видео' },
    { id: 'el_konsoles', lv: 'Spēļu konsoles', en: 'Game consoles', ru: 'Игровые консоли', children: [
      { id: 'el_kons_playstation', lv: 'PlayStation', en: 'PlayStation', ru: 'PlayStation' },
      { id: 'el_kons_xbox', lv: 'Xbox', en: 'Xbox', ru: 'Xbox' },
      { id: 'el_kons_nintendo', lv: 'Nintendo', en: 'Nintendo', ru: 'Nintendo' },
      { id: 'el_kons_speles', lv: 'Spēles', en: 'Games', ru: 'Игры' },
    ] },
    { id: 'el_sadzive', lv: 'Sadzīves tehnika', en: 'Appliances', ru: 'Бытовая техника', children: [
      { id: 'el_sadz_liela', lv: 'Lielā tehnika', en: 'Large appliances', ru: 'Крупная техника' },
      { id: 'el_sadz_maza', lv: 'Mazā tehnika', en: 'Small appliances', ru: 'Мелкая техника' },
    ] },
  ] },
  { id: 'majai_darzam', lv: 'Mājai un dārzam', en: 'Home & garden', ru: 'Для дома и сада', emoji: '🏡', children: [
    { id: 'maj_mebeles', lv: 'Mēbeles', en: 'Furniture', ru: 'Мебель', children: [
      { id: 'maj_meb_dzivojamai', lv: 'Dzīvojamai istabai', en: 'Living room', ru: 'Гостиная' },
      { id: 'maj_meb_gulamistabai', lv: 'Guļamistabai', en: 'Bedroom', ru: 'Спальня' },
      { id: 'maj_meb_virtuvei', lv: 'Virtuvei un ēdamistabai', en: 'Kitchen & dining', ru: 'Кухня' },
      { id: 'maj_meb_biroja', lv: 'Biroja mēbeles', en: 'Office furniture', ru: 'Офисная' },
    ] },
    { id: 'maj_interjers', lv: 'Interjers un dekori', en: 'Interior & decor', ru: 'Интерьер и декор' },
    { id: 'maj_virtuve', lv: 'Virtuves piederumi', en: 'Kitchenware', ru: 'Посуда' },
    { id: 'maj_darzs', lv: 'Dārzs', en: 'Garden', ru: 'Сад', children: [
      { id: 'maj_darzs_augi', lv: 'Augi un sēklas', en: 'Plants & seeds', ru: 'Растения' },
      { id: 'maj_darzs_tehnika', lv: 'Dārza tehnika', en: 'Garden tools', ru: 'Садовая техника' },
      { id: 'maj_darzs_mebeles', lv: 'Dārza mēbeles', en: 'Garden furniture', ru: 'Садовая мебель' },
    ] },
    { id: 'maj_instrumenti', lv: 'Instrumenti', en: 'Tools', ru: 'Инструменты' },
    { id: 'maj_buvmateriali', lv: 'Būvmateriāli', en: 'Building materials', ru: 'Стройматериалы' },
  ] },
  { id: 'transports', lv: 'Transports', en: 'Vehicles', ru: 'Транспорт', emoji: '🚗', children: [
    { id: 'tr_auto', lv: 'Automašīnas', en: 'Cars', ru: 'Легковые', children: [
      { id: 'tr_auto_vieglas', lv: 'Vieglās automašīnas', en: 'Passenger cars', ru: 'Легковые' },
      { id: 'tr_auto_suv', lv: 'Apvidus / SUV', en: 'SUV / off-road', ru: 'Внедорожники' },
      { id: 'tr_auto_kravas', lv: 'Kravas automašīnas', en: 'Trucks', ru: 'Грузовые' },
      { id: 'tr_auto_busi', lv: 'Mikroautobusi un autobusi', en: 'Vans & buses', ru: 'Микроавтобусы' },
    ] },
    { id: 'tr_moto', lv: 'Motocikli un mopēdi', en: 'Motorcycles', ru: 'Мотоциклы', children: [
      { id: 'tr_moto_motocikli', lv: 'Motocikli', en: 'Motorcycles', ru: 'Мотоциклы' },
      { id: 'tr_moto_skuteri', lv: 'Mopēdi un skūteri', en: 'Mopeds & scooters', ru: 'Мопеды и скутеры' },
      { id: 'tr_moto_kvadri', lv: 'Kvadricikli', en: 'ATVs', ru: 'Квадроциклы' },
    ] },
    { id: 'tr_velosipedi', lv: 'Velosipēdi', en: 'Bicycles', ru: 'Велосипеды' },
    { id: 'tr_dalas', lv: 'Rezerves daļas', en: 'Spare parts', ru: 'Запчасти', children: [
      { id: 'tr_dalas_auto', lv: 'Auto detaļas', en: 'Car parts', ru: 'Автозапчасти' },
      { id: 'tr_dalas_moto', lv: 'Moto detaļas', en: 'Moto parts', ru: 'Мотозапчасти' },
      { id: 'tr_dalas_riepas', lv: 'Riepas un diski', en: 'Tyres & rims', ru: 'Шины и диски' },
    ] },
    { id: 'tr_piekabes', lv: 'Piekabes un treileri', en: 'Trailers', ru: 'Прицепы' },
    { id: 'tr_udens', lv: 'Ūdens transports', en: 'Watercraft', ru: 'Водный транспорт' },
  ] },
  { id: 'bernu_precies', lv: 'Bērnu preces', en: 'Kids', ru: 'Детские товары', emoji: '🧸', children: [
    { id: 'ber_ratini', lv: 'Ratiņi', en: 'Strollers', ru: 'Коляски' },
    { id: 'ber_autokresli', lv: 'Autokrēsliņi', en: 'Car seats', ru: 'Автокресла' },
    { id: 'ber_mebeles', lv: 'Bērnu mēbeles', en: 'Kids furniture', ru: 'Детская мебель' },
    { id: 'ber_rotallietas', lv: 'Rotaļlietas', en: 'Toys', ru: 'Игрушки' },
    { id: 'ber_apgerbi', lv: 'Bērnu apģērbi un apavi', en: 'Kids clothing & shoes', ru: 'Детская одежда' },
  ] },
  { id: 'dzivnieki', lv: 'Dzīvnieki', en: 'Animals', ru: 'Животные', emoji: '🐾', children: [
    { id: 'dzi_suni', lv: 'Suņi', en: 'Dogs', ru: 'Собаки' },
    { id: 'dzi_kaki', lv: 'Kaķi', en: 'Cats', ru: 'Кошки' },
    { id: 'dzi_putni', lv: 'Putni', en: 'Birds', ru: 'Птицы' },
    { id: 'dzi_akvarijs', lv: 'Akvārijs un zivis', en: 'Aquarium & fish', ru: 'Аквариум' },
    { id: 'dzi_preces', lv: 'Dzīvnieku preces', en: 'Pet supplies', ru: 'Товары для животных' },
  ] },
  { id: 'sports_atputa', lv: 'Sports un atpūta', en: 'Sports & leisure', ru: 'Спорт и отдых', emoji: '⚽', children: [
    { id: 'spo_velo', lv: 'Velosipēdi', en: 'Bicycles', ru: 'Велосипеды' },
    { id: 'spo_trenazieri', lv: 'Trenažieri un fitness', en: 'Gym & fitness', ru: 'Тренажёры' },
    { id: 'spo_ziema', lv: 'Ziemas sports', en: 'Winter sports', ru: 'Зимний спорт', children: [
      { id: 'spo_ziema_slepes', lv: 'Slēpes', en: 'Skis', ru: 'Лыжи' },
      { id: 'spo_ziema_snovbords', lv: 'Snovbordi', en: 'Snowboards', ru: 'Сноуборды' },
      { id: 'spo_ziema_slidas', lv: 'Slidas un hokejs', en: 'Skates & hockey', ru: 'Коньки и хоккей' },
    ] },
    { id: 'spo_turisms', lv: 'Tūrisms un kempings', en: 'Camping & hiking', ru: 'Туризм' },
    { id: 'spo_udens', lv: 'Ūdens sports', en: 'Water sports', ru: 'Водный спорт' },
  ] },
  { id: 'pakalpojumi', lv: 'Pakalpojumi', en: 'Services', ru: 'Услуги', emoji: '🛠️', children: [
    { id: 'pak_remonts', lv: 'Remonts un celtniecība', en: 'Repair & construction', ru: 'Ремонт и стройка' },
    { id: 'pak_parvadajumi', lv: 'Transports un pārvadājumi', en: 'Transport & moving', ru: 'Перевозки' },
    { id: 'pak_skaistums', lv: 'Skaistumkopšana', en: 'Beauty', ru: 'Красота' },
    { id: 'pak_macibas', lv: 'Mācības un kursi', en: 'Lessons & courses', ru: 'Обучение' },
    { id: 'pak_it', lv: 'IT un dizains', en: 'IT & design', ru: 'IT и дизайн' },
  ] },
  { id: 'cits', lv: 'Cits', en: 'Other', ru: 'Другое', emoji: '📦', children: [
    { id: 'cit_gramatas', lv: 'Grāmatas', en: 'Books', ru: 'Книги' },
    { id: 'cit_muzika', lv: 'Mūzikas instrumenti', en: 'Musical instruments', ru: 'Муз. инструменты' },
    { id: 'cit_kolekcijas', lv: 'Kolekcionēšana', en: 'Collectibles', ru: 'Коллекции' },
    { id: 'cit_cits', lv: 'Pārējais', en: 'Miscellaneous', ru: 'Прочее' },
  ] },
];

// Top-level categories (backward compatible — no children). Used by the map
// emoji system + legacy consumers.
export const CLASSIFIED_CATEGORIES = CLASSIFIED_TAXONOMY.map(({ children, ...c }) => c);
export const CLASSIFIED_CATEGORY_MAP = Object.fromEntries(CLASSIFIED_CATEGORIES.map((c) => [c.id, c]));

// Flat map of EVERY node (all levels) → node (with inherited top emoji) +
// parent + top pointers, for resolving labels / paths anywhere.
export const CATEGORY_NODE_MAP = {};
(function buildFlat() {
  const walk = (nodes, parentId, topId, topEmoji) => {
    for (const n of nodes) {
      const top = topId || n.id;
      const emoji = n.emoji || topEmoji || '📦';
      CATEGORY_NODE_MAP[n.id] = { id: n.id, lv: n.lv, en: n.en, ru: n.ru, emoji, parent: parentId || null, top };
      if (n.children) walk(n.children, n.id, top, emoji);
    }
  };
  walk(CLASSIFIED_TAXONOMY, null, null, null);
})();

// Resolve a category by id across ALL levels. `catMap` (optional) carries
// admin-approved CUSTOM categories fetched from /api/classifieds/meta/categories.
export function resolveCat(id, catMap) {
  return (catMap && catMap[id]) || CATEGORY_NODE_MAP[id] || CLASSIFIED_CATEGORY_MAP[id]
    || { id, lv: id, en: id, ru: id, emoji: '📦' };
}

// Full id path from top → the given node (inclusive). Falls back to [id].
export function categoryPath(id, tree = CLASSIFIED_TAXONOMY) {
  const dfs = (nodes, trail) => {
    for (const n of nodes) {
      const next = [...trail, n.id];
      if (n.id === id) return next;
      if (n.children) { const r = dfs(n.children, next); if (r) return r; }
    }
    return null;
  };
  return dfs(tree, []) || (id ? [id] : []);
}

// Children of a node id (or the top-level nodes when id is falsy).
export function categoryChildren(id, tree = CLASSIFIED_TAXONOMY) {
  if (!id) return tree;
  const dfs = (nodes) => {
    for (const n of nodes) {
      if (n.id === id) return n.children || [];
      if (n.children) { const r = dfs(n.children); if (r) return r; }
    }
    return null;
  };
  return dfs(tree) || [];
}

// Merge admin-approved CUSTOM categories (flat list with `parent`) into a copy
// of the fixed tree so they appear in the cascading selects + browse chips.
export function mergeCustomCategories(customs = [], tree = CLASSIFIED_TAXONOMY) {
  const clone = JSON.parse(JSON.stringify(tree));
  const findNode = (nodes, id) => {
    for (const n of nodes) {
      if (n.id === id) return n;
      if (n.children) { const r = findNode(n.children, id); if (r) return r; }
    }
    return null;
  };
  for (const c of customs) {
    if (!c || !c.custom) continue;
    const node = { id: c.id, lv: c.lv, en: c.en || c.lv, ru: c.ru || c.lv, emoji: c.emoji || '📦' };
    const parent = c.parent ? findNode(clone, c.parent) : null;
    if (parent) { parent.children = parent.children || []; if (!parent.children.some((x) => x.id === node.id)) parent.children.push(node); }
    else if (!clone.some((x) => x.id === node.id)) clone.push(node);
  }
  return clone;
}

export const PRICE_TYPES = [
  { id: 'fixed', lv: 'Fiksēta', en: 'Fixed', ru: 'Фиксированная' },
  { id: 'negotiable', lv: 'Runājama', en: 'Negotiable', ru: 'Договорная' },
  { id: 'swap', lv: 'Maiņa', en: 'Swap', ru: 'Обмен' },
];

export const PRICE_TYPE_MAP = Object.fromEntries(PRICE_TYPES.map((p) => [p.id, p]));

// Format a classified's price for display given the active language helper `tr`.
export function formatClassifiedPrice(item, tr) {
  if (item.price_type === 'swap') return tr('Maiņa', 'Swap', 'Обмен');
  const amount = typeof item.price === 'number' ? `€${item.price.toFixed(2)}` : '';
  if (item.price_type === 'negotiable') return amount ? `${amount} · ${tr('runājama', 'negotiable', 'договорная')}` : tr('Runājama', 'Negotiable', 'Договорная');
  return amount || '—';
}
